import { CoreIcon } from '../core-icon';
import zoomOutSVG from '../../assets/icons/zoom-out.svg';
import type { IconProps } from '../core-icon';

export const ZoomOutIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={zoomOutSVG} {...props} />;
};
